// extracted by mini-css-extract-plugin
export var centerText = "_80-8";
export var container = "_80-0";
export var doughnutContainer = "_80-7";
export var legend = "_80-a";
export var legendItemColorDisplay = "_80-b";
export var legendItemLabel = "_80-d";
export var legendItemValue = "_80-c";
export var lg = "_80-5";
export var maxWidth = "_80-9";
export var md = "_80-4";
export var responsive = "_80-6";
export var sm = "_80-3";
export var xs = "_80-2";
export var xxs = "_80-1";